import Vue from 'vue';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend, localize, validate } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import en from "vee-validate/dist/locale/en.json";
import { min } from 'vee-validate/dist/rules';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
localize({ en });

Object.keys(en.messages).forEach(key => extend(key, rules[key]) );

extend('email', {
    message: 'Please enter correct email.'
});

extend('required', {
    message: 'This field is required.'
});

extend("passwordValid", {
    validate(value) {
        const rules = [
            { regex: /[a-z]/, label: "lowercase letters" },
            { regex: /[A-Z]/, label: "uppercase letters" },
            { regex: /\d/, label: "numbers" },
            { regex: /[@#$^&*+=]/, label: "special characters (@#$^&*+=)" },
        ];

        const passedChecks = rules.filter(rule => rule.regex.test(value)).length;

        if (passedChecks < 3) {
            return {
                valid: false,
                message: `Password must contain at least three of the following: ${rules
                    .map(rule => rule.label)
                    .join(", ")}.`,
            };
        }

        return { valid: true };
    },
});
extend('password_strength', {
    validate(value) {
        const pwd = value || '';
        const minLength = pwd.length >= 8;
        const lower = /[a-z]/.test(pwd);
        const upper = /[A-Z]/.test(pwd);
        const digit = /\d/.test(pwd);
        const special = /[@#$^&*+=]/.test(pwd);
        const passed = [lower, upper, digit, special].filter(Boolean).length;
        return minLength && passed >= 3;
    },
    message:
        'Password must be at least 8 characters long and contain at least three of the following: lowercase, uppercase, number, or special (@#$^&*+=).'
});

extend('latin', {
    validate(value) {
        const latinRegex = /^[a-zA-Z\s!@#$%^&*()\-_=+[{\]};:'",<.>/?]*$/;
        return latinRegex.test(value);
    },
    message: 'The field may only contain Latin letters.'
});

const validationSchema1 = {
    name: 'required|latin',

};

extend('latinAndNumbers', {
    validate(value) {
        const latinNumRegex = /^[A-Za-z0-9\s!@#$%^&*()\-_=+[{\]};:'",<.>/?]+$/;
        return latinNumRegex.test(value);
    },
    message: 'The field may only contain numbers and Latin characters.'
});

const validationSchema2 = {
    name: 'required|latinAndNumbers',

};

extend('customMin', {
    ...min,
    message: 'Please enter full number '
});

extend("customNumeric", {
    validate(value) {
        const regex = /^[0-9.,]+$/;
        return regex.test(value);
    },
    message: "The field must be a number and can contain commas or dots"
});

